import { getStylesObjFromCss } from "../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    root: {
      maxWidth: "342px",
      overflowY: "auto",
      backgroundColor: "#F6F8F9",
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#F5F5F5",
        WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
      },
      "&::-webkit-scrollbar": {
        width: "6px",
        backgroundColor: "#F5F5F5",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#555",
        WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
      },
    },

    backgroundContainer: {
      position: "relative",
      width: "100%",
    },

    curvedBackground: {
      height: "300px",
      borderRadius: "0 0 24px 24px",
      marginTop: "-176px",
    },

    contentContainer: {
      padding: "0 5px",
      marginTop: "-110px",
    },

    profileCard: {
      borderRadius: "24px",
      overflow: "hidden",
      backgroundColor: "#FEFEFE",
      marginLeft: "8px",
      marginRight: "8px",
      marginBottom: "15px",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      border: "1px solid #FFFFFF",
    },

    coverImage: {
      width: "100%",
      height: "180px",
      minHeight: "180px",
      maxHeight: "180px",
      objectFit: "cover",
      display: "block",
    },

    profileContent: {
      padding: "16px",
    },

    config: {
      padding: "0 12px 24px",
    },

    divider: {
      margin: "8px 0",
      background: "#E9E9E9",
      height: "1px",
      border: "none",
    },
  },
  componentName: "SidebarWrapper",
});
